/**
 * The reseller's saved setup as the demo tab sees it: read once by boot.ts from the real storage before
 * the tab is sealed, then used by fixtures.ts for prices, packages, coupons and payment methods.
 */
import { INITIAL_SETUP, type SetupState } from '../setup/setupState';

export const demoTenant: { s: SetupState } = { s: INITIAL_SETUP };
